import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import Footer from '@Components/Footer';

import NoAlerts from './AlertsComponents/NoAlerts';
import GroupsList from './AlertsComponents/GroupsList';

import './Alerts.custom.scss';
import './Alerts.theme.scss';

export default function Alerts(props) {
  const { groupsIds } = props;
  const result = groupsIds && (groupsIds.count() ? <GroupsList groupsIds={groupsIds} /> : <NoAlerts />);

  return (
    <div className="results-wrapper">
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
      <div id="main-content" tabIndex="0" className="page-container results-wrapper-inner" aria-labelledby="history-title">
        <div className="rx-view heading-container header-container--border-bottom left-gutter right-gutter">
          <div className="heading-container--alerts u-els-padding-top-1x u-els-padding-bottom-1x">
            <h1 id="alerts-title" className="u-els-font-size-h3">
              Alerts
            </h1>
          </div>
        </div>

        <section className="left-gutter right-gutter rx-list-wrapper">
          <div className="alerts-items-wrapper">{result}</div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

Alerts.propTypes = {
  groupsIds: PropTypes.instanceOf(List),
};
